/**
 * @generated SignedSource<<c99b19aaee43fd60f333f6d78ea53517>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderInlineDataFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type BranchPickerSharedRef$data = {
  readonly __typename: "Ref";
  readonly associatedPullRequests: {
    readonly totalCount: number;
  };
  readonly id: string;
  readonly name: string;
  readonly repository: {
    readonly defaultBranchRef: {
      readonly associatedPullRequests: {
        readonly totalCount: number;
      };
      readonly id: string;
      readonly name: string;
      readonly repository: {
        readonly id: string;
      };
      readonly target: {
        readonly __typename: string;
        readonly id: string;
        readonly oid: any;
      } | null | undefined;
    } | null | undefined;
    readonly id: string;
    readonly nameWithOwner: string;
  };
  readonly target: {
    readonly __typename: string;
    readonly id: string;
    readonly oid: any;
  } | null | undefined;
  readonly " $fragmentType": "BranchPickerSharedRef";
};
export type BranchPickerSharedRef$key = {
  readonly " $data"?: BranchPickerSharedRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"BranchPickerSharedRef">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "BranchPickerSharedRef"
};

(node as any).hash = "074c41183822ce4769d51cb770c375e7";

export default node;
